import { Stack, Text } from '@mantine/core';

type WorkOrderLocationProps = {
  locationId: string | null;
  locationName: string | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  country: string | null;
};

export default function WorkOrderLocation({
  locationId,
  locationName,
  address1,
  address2,
  city,
  state,
  zip,
  country,
}: WorkOrderLocationProps) {
  const searchUrl = `https://www.google.com/maps/search/${encodeURI(`${address1} ${address2} ${city} ${state} ${zip} ${country}`)}`;

  return (
    <Stack gap={0}>
      <Text fw={600} size="sm">
        {`${locationName}${locationId ? ` (${locationId})` : ''}`}
      </Text>
      {address1 && (
        <Text
          size="sm"
          variant="link"
          fw={400}
          c="blue"
          td="underline"
          style={{ whiteSpace: 'pre-wrap', cursor: 'pointer' }}
          onClick={() => window.open(searchUrl, '_blank')}
        >
          {address1 && `${address1}\n`}
          {address2 && `${address2}\n`}
          {`${city}, ${state} ${zip} ${country}\n`}
        </Text>
      )}
    </Stack>
  );
}
